import React, { useState } from "react";


import {
    ref,
    uploadBytes,
} from "firebase/storage";
import { storage } from '../firebase';
import { v4 } from "uuid";

import { Form, Alert, InputGroup, Button, ButtonGroup, Card } from "react-bootstrap";
import BookDataService from "../services/book.homevisit";




const AddHomevisit = () => {

    const [imageUpload, setImageUpload] = useState(null);


    const [selectedTime, setSelectedTime] = useState(null)


    const uploadFile = () => {
        if (imageUpload == null) return;
        const imageRef = ref(storage, `prescription/${imageUpload.name + v4()}`);
        uploadBytes(imageRef, imageUpload).then((snapshot) => {
            alert("Prescription Uploaded Seccessful")
        });

    };










    return (
        <>


            <div className="album py-0">
                <div className="container">
                   
                        <h3 style={{ color: "#3D2814" }} className="mt-0 mb-3 mt-2" ><b>Upload Prescription</b></h3>
                    
                    <div className="row ">
                        <div className="col-md-12">





                            <div style={{ margin: "6px" }} className="card mb-4 box-shadow ">





                                <input style={{ margin: "8px" }} className="mb-3 mt-3"
                                    type="file"
                                    onChange={(event) => {
                                        setImageUpload(event.target.files[0]);
                                    }}
                                />
                                <p style={{ margin: "10px", color: "maroon" }}>Upload Prescriptions </p>


                                {/* <div className='time-picker mt-3 mb-2'>
                    <TimePickerComponent onChange= {(e) => setSelectedTime(e.target.value)} placeholder='Select a time' min={minTime} max={maxTime} value ={ selectedTime } required>

                    </TimePickerComponent>
                </div>  */}


                                <div className="d-grid gap-2 mb-2">
                                    <button onClick={uploadFile} className="petprescription">  Submit </button>
                                </div>



                            </div>

                        </div>
                    </div>
                </div>
            </div>



        </>


    )
}
export default AddHomevisit;